
import { Vue, Component } from 'vue-property-decorator';
import { PleasedUserInfo } from '@/common/types';
import { namespace } from 'vuex-class';
import { ListTicketDetail } from '@/common/api/models.pleased';
import { emitOpenMyRequest } from '@/common/eventBus';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import { getRecentResolvedTicket } from '@/common/userRequest';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

const userModule = namespace('user');

@Component({
  components: {
    FaAngleRight,
  },
  directives: {
    trackClick,
  },
})
export default class ResolvedRequestBanner extends Vue {
  @userModule.State('pleasedUser') pleasedUser!: PleasedUserInfo;

  readonly BTN_EVTS = BTN_EVTS;

  ticket: ListTicketDetail | null = null;

  created () {
    this.fetchTicket();
  }

  async fetchTicket () {
    const data = await getRecentResolvedTicket(this.pleasedUser.userId);

    if (!data || !data.ticket || data.ticketReviews.length > 0) {
      return;
    }

    this.ticket = data.ticket;
  }

  viewDetails () {
    if (!this.ticket) {
      return;
    }

    emitOpenMyRequest(true);
  }
}
